<template>
  <sui-page>
    <sui-page-header
      :pageId="this.$options.name"
    />
    <sui-page-contents>
      <div
        class="comm_scr_wrap"
        style="border: none !important;background-color: #fff !important;"
      >
        <div
          class="row"
          style="border:none !important;background-color: #fff !important;height: 28px;"
        >
          <div class="col-xs-1" style="background-color:#ffffff !important">
            <sui-input-label
              :label="$t('MSG_TXT_AUTH_SRCH_TYPE')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="radioValue"
              value="T"
              @input="onChangeData"
            >
              {{ $t('MSG_TXT_TASK_BASE') }}
            </sui-radio>
            <sui-radio
              v-model="radioValue"
              value="C"
              @input="onChangeData"
            >
              {{ $t('MSG_TXT_COLLG_BASE') }}
            </sui-radio>
          </div>

        </div>
      </div>
      <div class="mrB10" />
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              :pageId="this.$options.name"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              v-if="'C' === selectTaskValue"
              :label="$t('MSG_TXT_USR')"
              :vertical="false"
              required
            />
            <sui-input-label
              v-else
              :label="$t('MSG_TXT_USER_GRP_NAME')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-select
              ref="userSelect"
              v-if="'C' === selectTaskValue"
              :selectedUser="selectedUser"
              :readonly="false"
              :checkboxMode="false"
              @selected="onSelectedUser"
            />
            <sui-text-field
              v-else
              v-model="userGroupName"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onReset"
            >
              {{ $t('MSG_BTN_RESET') }}
            </sui-button>
            <sui-button
              v-permission:read="'PGE_CMA_00005'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearch"
            >
              {{ $t('MSG_BTN_SEARCH') }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="mrB10" />
          <sui-grid
            v-show="'C' === selectTaskValue"
            ref="grdListC"
            :initialPagesize="10"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :multiselect="true"
            :pageable="false"
            :sortable="false"
            :filterable="false"
            :columns="gridColumnCol"
            :columnsresize="true"
            :columnsautoresize="true"
            :enabletooltips="true"
            width="100%"
            :dataset="'dsData'"
          />
          <sui-grid
            v-show="'T' === selectTaskValue"
            ref="grdListT"
            :initialPagesize="10"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :multiselect="true"
            :pageable="false"
            :sortable="false"
            :filterable="false"
            :columns="gridColumnTsk"
            :columnsresize="true"
            :columnsautoresize="true"
            :enabletooltips="true"
            width="100%"
            :dataset="'dsData'"
          />
          <div style="display: inline-flex;margin-top: 12px;justify-content:center; width:100%;">
            <sui-button
              type="button"
              class="comm_btn_shut_down"
              @click="onAddItems"
            />
            <div style="width:12px;" />
            <sui-button
              type="button"
              class="comm_btn_shut_up"
              @click="onDeleteItems"
            />
          </div>
        </div>
        <div class="emptybox" />
        <div class="inbox">
          <div class="mrB40" />
          <div class="comm_view_wrap">
            <div class="row">
              <div class="col-xs-2">
                <sui-input-label
                  :label="$t('MSG_TXT_USER_GRP_NAME')"
                  :vertical="false"
                />
              </div>
              <div class="col-xs-4">
                <div
                  class="comm_label"
                >
                  {{ detailUserGrpName }}
                </div>
              </div>
              <div class="col-xs-2">
                <sui-input-label
                  :label="$t('MSG_TXT_TASK_TYPE')"
                  :vertical="false"
                />
              </div>
              <div class="col-xs-4">
                <div
                  class="comm_label"
                >
                  {{ detailTaskName }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-2">
                <sui-input-label
                  :label="$t('MSG_TXT_EXPL')"
                  :vertical="false"
                />
              </div>
              <div class="col-xs-10">
                <div
                  class="comm_label"
                >
                  {{ detailUserGrpCntn }}
                </div>
              </div>
            </div>
          </div>
          <div class="mrB10" />
          <sui-tree-grid
            ref="grdAppMenu"
            :columns="treeGridColumns"
            :dataset="'dsTreeData'"
            :selectionMode="'singleRow'"
            :height="308"
          />
        </div>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{ $t('MSG_TXT_APPL_AUTH_LIST') }}</h4>
          </div>
          <sui-grid
            ref="grdAuth"
            :columns="gridAuthColumn"
            :dataset="'dsAuth'"
            :multiselect="true"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :pageable="false"
            :sortable="false"
            :filterable="false"
            :columnsresize="true"
            :columnsautoresize="true"
            :enabletooltips="true"
            :initialPagesize="5"
          />
          <div class="comm_title_wrap">
            <span class="sui-input-label__star" />
            <h4>{{ $t('MSG_TXT_AUTH_APPL_RSN') }}</h4>
          </div>
          <textarea
            v-model="authApplRsn"
            style="height:138px"
            maxlength="1000"
          />
          <div class="mrB30" />
        </div>
        <div class="emptybox" />
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{ $t('MSG_TXT_PSS_AUTH_LIST') }}</h4>
            <div class="comm_line_div" />
            <div class="comm_infowrap">
              <p>{{ $t('MSG_TXT_AUTH_INFO') }}</p>
            </div>
          </div>
          <sui-grid
            ref="grdPssAuthList"
            :columns="columnPssAuthList"
            :dataset="'dsPssAuthList'"
            :multiselect="false"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :pageable="false"
            :sortable="false"
            :filterable="false"
            :columnsresize="true"
            :columnsautoresize="true"
            :enabletooltips="true"
            :initialPagesize="10"
          />
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapR">
          <sui-button
            type="button"
            class="comm_btn_solid"
            @click="onAuthAppl"
          >
            {{ $t('MSG_BTN_AUTH_APPL') }}
          </sui-button>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMA_00005', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      authApplRsn: '',
      customOptions: [],
      userInfo: {},
      radioValue: 'T',
      selectedBizCode: [],
      userGroupName: '',
      selectedUser: { userName: '', epId: '' },
      detailUserGrpName: '',
      detailTaskName: '',
      detailUserGrpCntn: '',
      localdata0: [],
      gridColumnTsk: [
        {
          text: this.$t('MSG_TXT_USER_GRP_NAME'),
          datafield: 'userGroupName',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onSelectGrid,
              type: 'link',
            }, this.dsData, this.$refs.grdListT);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: '200',
        },
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
        },
        {
          text: this.$t('MSG_TXT_STT'),
          datafield: 'authRequestStatusName'
        },
      ],
      gridColumnCol: [
        {
          text: this.$t('MSG_TXT_USER_GRP_NAME'),
          datafield: 'userGroupName',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onSelectGrid,
              type: 'link',
            }, this.dsData, this.$refs.grdListC);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: '200',
        },
        { text: this.$t('MSG_TXT_TASK_TYPE'), datafield: 'taskName' },
        {
          text: this.$t('MSG_TXT_STT'),
          datafield: 'authRequestStatusName',
          width:'100'
        },
      ],
      treeGridData: [],
      treeGridColumns: [
        { text: this.$t('MSG_TXT_MENU'), datafield: 'value' },
      ],
      localdata2: [],
      gridAuthColumn: [
        { text: this.$t('MSG_TXT_USER_GRP_NAME'), datafield: 'userGroupName' },
        { text: this.$t('MSG_TXT_TASK_TYPE'), datafield: 'taskName' },
      ],
      localdata3: [],
      columnPssAuthList: [
        { text: this.$t('MSG_TXT_USER_GRP_NAME'), datafield: 'userGroupName' },
        { text: this.$t('MSG_TXT_TASK_TYPE'), datafield: 'taskName' },
        { text: this.$t('MSG_TXT_STT'), datafield: 'authRequestStatusName' },
      ],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
    selectTaskValue() {
      return this.radioValue;
    },
  },
  watch: {
  },
  datasets: [
    {
      id: 'dsData',
      type: 'local',
      data: 'localdata0',
      datafields: [
//        { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
        { name: 'userGroupId', type: 'string', map: 'userGroupId' },
        { name: 'userGroupName', type: 'string', map: 'userGroupName' },
        { name: 'taskId', type: 'string', map: 'taskId' },
        { name: 'taskName', type: 'string', map: 'taskName' },
        { name: 'authRequestStatusCode', type: 'string', map: 'authRequestStatusCode' },
        { name: 'authRequestStatusName', type: 'string', map: 'authRequestStatusName' },
      ],
    },
    {
      id: 'dsTreeData',
      componentType: 'tree-grid',
      data: 'treeGridData',
      hierarchy: {
        keyDataField: {
          name: 'id',
        },
        parentDataField: {
          name: 'parentId',
        },
      },
      datafields: [
        { name: 'id', type: 'string', map: 'id' },
        { name: 'parentId', type: 'string', map: 'parentId' },
        { name: 'level', type: 'string', map: 'level' },
        { name: 'value', type: 'string', map: 'value' },
        { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      ],
    },
    {
      id: 'dsAuth',
      type: 'local',
      data: 'localdata2',
      datafields: [
//        { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
        { name: 'userGroupId', type: 'string', map: 'userGroupId' },
        { name: 'userGroupName', type: 'string', map: 'userGroupName' },
        { name: 'taskId', type: 'string', map: 'taskId' },
        { name: 'taskName', type: 'string', map: 'taskName' },
      ],
    },
    {
      id: 'dsPssAuthList',
      type: 'local',
      data: 'localdata3',
      datafields: [
//        { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
        { name: 'authRequestUid', type: 'string', map: 'authRequestUid' },
        { name: 'userId', type: 'string', map: 'userId' },
        { name: 'userGroupId', type: 'string', map: 'userGroupId' },
        { name: 'userGroupName', type: 'string', map: 'userGroupName' },
        { name: 'gbmCode', type: 'string', map: 'gbmCode' },
        { name: 'authRequestStatusCode', type: 'string', map: 'authRequestStatusCode' },
        { name: 'authRequestStatusName', type: 'string', map: 'authRequestStatusName' },
        { name: 'taskId', type: 'string', map: 'taskId' },
        { name: 'taskName', type: 'string', map: 'taskName' },
      ],
    },
  ],
  mounted() {
    //this.dsData.$on(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    this.load();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    if (this.dsData) {
      //this.dsData.$off(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    }
  },
  destroyed() {},
  methods: {
    onKeyUpInput() {
      const searchFieldNewText = this.condContent;
      if (utils.isempty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.condContent = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onReset() {
      this.selectedBizCode = [];
      if (utils.isEqual(this.radioValue, 'T') === true) {
        this.userGroupName = '';
      } else {
        this.selectedUser.userName = '';
      }
      this.$refs.taskIdSelect.reset();
      this.$refs.userSelect.reset();
    },
    onSearch() {
      let taskId = '';
      if (this.selectedBizCode[2].key !== 'ALL') {
        taskId = utils.trim(this.selectedBizCode[2].key);
      } else if (this.selectedBizCode[1].key !== 'ALL') {
        taskId = utils.trim(this.selectedBizCode[1].key);
      } else if (this.selectedBizCode[0].key !== 'ALL') {
        taskId = utils.trim(this.selectedBizCode[0].key);
      }

      let queryParams = {};
      let dataService = '';
      if (utils.isEqual(this.radioValue, 'T') === true) {
        const condTypeCode = 'USR_GRP_NM';
        queryParams = {
          taskId: taskId || '',
          searchCond: condTypeCode,
          searchWord: utils.toUpper(this.userGroupName) || '',
          basicAuthYn: 'N',
          portalId: this.userInfo.portalId,
          authApplyObjectYn: 'Y',
        };
        dataService = 'DTS_CMA_00008';
      } else {
        if (utils.isEmpty(this.selectedUser.userName) === true) {
          const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_USR'));
          utils.messageBox('error', msg);
          return;
        }

        if (utils.isEmpty(this.selectedUser.epId) === true) {
          utils.messageBox('error', this.$t('MSG_ALT_NO_SEARCH_USR'));
          return;
        }
        queryParams = {
          taskId: taskId || '',
          userId: this.selectedUser.epId,
        };
        dataService = 'DTS_CMA_00032';
      }

      http.request(this.$options.name, dataService, {
        query: queryParams,
      }).then(res => {
        this.dsData.clearSelection();
        if (res.data) {
          utils.forEach(res.data, item => {
            const idx = utils.findIndex(this.dsPssAuthList.data, o => utils.isEqual(o.userGroupId, item.userGroupId));
            if (idx >= 0) {
              item.authRequestStatusName = this.dsPssAuthList.data[idx].authRequestStatusName;
            }
          })
          this.dsData.setRawData(res.data);
        } else {
          this.dsData.setRawData([]);
        }
        this.DetailInit();
      }).catch(error => {
        console.log(error);
      });
    },
    onAddItems() {
      const indexes = this.dsData.getSelectedIndexes();

      const shiftData = [];
      let alreadyHaveCount = 0;
      utils.forEach(indexes, index => {

        const item = this.dsData.data[index];
        const idx = utils.findIndex(this.dsAuth.data, o => utils.isEqual(o.userGroupId, item.userGroupId));
        if (!utils.isEmpty(item.authRequestStatusName)) {
          alreadyHaveCount += 1;
          return;
        }
        if (idx < 0) {
          shiftData.push(utils.cloneDeep(item));
        }
      });
      if (alreadyHaveCount > 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_ALREADY_HAVE_AUTH'));
      }
      this.dsAuth.addRows(shiftData);
    },
    onDeleteItems() {
      if (this.dsAuth.data.length > 0) {
        const selectedIndexes = this.dsAuth.getSelectedIndexes();
        this.dsAuth.deleteRows(selectedIndexes);
      }
    },
    onSelectGrid(btn, dataRow) {
      this.selectedGridRowData = dataRow;
      const userGroupId = this.selectedGridRowData ? this.selectedGridRowData.userGroupId : '';
      if (!utils.isEmpty(userGroupId)) {
        this.searchDetail(userGroupId);
      }
    },
    onSelectedUser(selectedData) {
      if (null != selectedData) {
        this.selectedUser.userName = selectedData.userName;
        this.selectedUser.epId = selectedData.epId;
      }
      else {
        this.selectedUser.userName = '';
        this.selectedUser.epId = '';
      }
    },
    onChangeData() {
      this.dsData.setRawData([]);
    },

    onAuthAppl() {
      if (utils.isEmpty(utils.trim(this.authApplRsn))) {
        const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_AUTH_APPL_RSN'));
        utils.messageBox('warning', msg);
        return;
      }

      if (this.dsAuth.data.length > 0) {
        const sendData = [];

        //이미 신청되거나 보유중인 권한 체크
        utils.forEach(this.dsAuth.data, item => {
          const idx = utils.findIndex(this.dsPssAuthList.data, o => utils.isEqual(o.userGroupId, item.userGroupId));
          if (idx < 0) {
            sendData.push(
              {
                userGroupId: utils.trim(item.userGroupId),
                taskId: utils.trim(item.taskId),
                authRequestStatusCode: 'S',
                authApprovalOpinionContent: this.authApplRsn || '',
              },
            );
          }
        });
        if (sendData.length != this.dsAuth.data.length) {
          utils.messageBox('warning', this.$t('MSG_ALT_ALREADY_HAVE_AUTH'));
          return;
        }

        if (sendData.length > 0) {
          http.request(this.$options.name, 'DTS_CMA_00033', {
            data: sendData,
          }).then(() => {
            this.dsAuth.setRawData([]);
            this.dsAuth.submit();
            this.dsData.submit();
            this.authApplRsn = '';
            const msg = utils.strFormat(this.$t('MSG_ALT_HAS_BEEN_COMPLETED'), this.$t('MSG_BTN_AUTH_APPL'));
            utils.messageBox('warning', msg);
            this.getPssAuthList(this.userInfo.userId);
          }).catch(error => {
            console.log(error);
          });
        }
      } else {
        const msg = utils.strFormat(this.$t('MSG_ALT_NO_ITEM'), this.$t('MSG_BTN_AUTH_APPL'));
        utils.messageBox('warning', msg);
      }
    },
    getPssAuthList(userId) {
      if (utils.isEmpty(userId) === false) {
        http.request(this.$options.name, 'DTS_CMA_00031', {
          path: { 'user-id': userId },
        }).then(res => {
          if (res.data) {
            this.dsPssAuthList.setRawData(res.data);
          } else {
            this.dsPssAuthList.setRawData([]);
          }
          this.dsPssAuthList.submit();
        }).catch(error => {
          console.log(error);
        });
      }
    },
    load() {
      this.userInfo = this.$store.getters.userInfo;

      this.getPssAuthList(this.userInfo.userId);
      this.$refs.taskIdSelect.reset();
    },
    searchDetail(userGroupId) {
      if (utils.isEmpty(userGroupId) === false) {
        http.request(this.$options.name, 'DTS_CMA_00009', {
          path: { 'user-group-id': userGroupId },
        }).then(res => {
          if (res.data) {
            //sonarcube codesmell 대응
            // if (res.data != null) {
              this.detailUserGrpName = res.data.userGroupName;
              this.detailTaskName = res.data.taskName;
              this.detailUserGrpCntn = res.data.userGroupContent;
            // } else {
            //   this.detailUserGrpName = '';
            //   this.detailTaskName = '';
            //   this.detailUserGrpCntn = '';
            // }
          } else {
            this.detailUserGrpName = '';
            this.detailTaskName = '';
            this.detailUserGrpCntn = '';
          }
        }).catch(error => {
          console.log(error);
        });
        this.searchMenu(userGroupId);
      }
    },
    searchMenu(userGroupId) {
      http.request(this.$options.name, 'DTS_CMA_00048', {
        path: { 'user-group-id' : userGroupId },
      }).then(res => {
        const treeData = [];
        utils.forEach(res.data, item => {
          treeData.push({
            id: item.menuId,
            parentId: item.parentId,
            level: item.menuLevel,
            value: item.menuName,
          });
        });
        this.dsTreeData.setRawData(treeData);
      }).catch(error => {
        console.log(error);
      });
    },
    DetailInit() {
      this.detailUserGrpName = '';
      this.detailTaskName = '';
      this.detailUserGrpCntn = '';
      this.dsTreeData.setRawData([]);
    },
    onListClicked(event, item) {
      this.$refs.taskIdSelect.reset();
    },
  },
};
</script>
<style scoped>
</style>
